import { createContext } from 'react'
import type { UseCasesSimplifiedReturn } from '@/types'

export const casesContext = createContext<UseCasesSimplifiedReturn | undefined>(
  undefined,
)
